/* Jeriack Snacks, theme behaviour
   Kept intentionally light. The marquees are pure CSS; this handles
   progressive enhancement: duplicating marquee content for a seamless loop,
   the add-to-cart drawer and the in-place cart page. */
(function () {
  "use strict";

  /* ---------- Diagnostics, tracking v3 (2026-10-04) ----------
     Short jeriack_* events for the journey dashboard, listed in
     Landing-funnel/DRAWER-TRACKING.md. Rules: every handler swallows its own
     errors, nothing here waits, delays or calls preventDefault, and every event
     name has a cap per page view. Field keys never contain mail, phone, tel,
     addr, name, zip or postal (the pixel drops those) and values are short codes.
     The error listeners come first so they catch as much as they can; errors
     before this file runs are missed (layout/theme.liquid stays untouched). */
  var sentCount = {};
  function trackCapped(name, data, max) {
    sentCount[name] = (sentCount[name] || 0) + 1;
    if (sentCount[name] <= max) track(name, data);
  }

  var pageKind = "";
  function pageType() {
    if (pageKind) return pageKind;
    var kind = "other";
    try {
      var body = document.body ? " " + document.body.className + " " : "";
      if (document.querySelector("[data-ob], [data-offer]") || /[?&]view=offer/.test(location.search)) kind = "offer";
      else if (body.indexOf(" template-cart ") > -1) kind = "cart";
      else if (body.indexOf(" template-product ") > -1) kind = "product";
      else if (body.indexOf(" template-index ") > -1) kind = "home";
      if (document.readyState !== "loading") pageKind = kind;
    } catch (e) {}
    return kind;
  }

  /* File name only, never a full URL. */
  function fileOf(u) {
    try {
      var s = String(u || "");
      if (!s) return "none";
      var url = new URL(s, location.href);
      if (!/^https?:$/.test(url.protocol)) return url.protocol.replace(":", "") || "unknown";
      if (url.origin === location.origin && url.pathname === location.pathname) return "inline";
      return (url.pathname.split("/").filter(Boolean).pop() || url.hostname).slice(0, 40);
    } catch (e) { return "unknown"; }
  }

  function shortMsg(m) {
    try {
      var s = String(m == null ? "" : m).replace(/\s+/g, " ").trim();
      if (/^Script error\.?$/.test(s)) return "Script error.";
      s = s.replace(/^Uncaught\s+/, "").replace(/\d{5,}/g, "#").slice(0, 40);
      if (s.indexOf("@") > -1) return "redacted";
      return s || "none";
    } catch (e) { return "none"; }
  }

  var errSeen = {};
  function jsError(kind, msg, src, line) {
    try {
      var key = kind + "|" + msg + (kind === "resource" ? "|" + src : "");
      if (errSeen[key]) return;
      errSeen[key] = true;
      trackCapped("jeriack_js_error", { kind: kind, msg: msg, src: src, line: Number(line) || 0, page: pageType() }, 3);
    } catch (e) {}
  }

  try {
    /* Script errors reach window itself; failed loads only show in the capture phase. */
    window.addEventListener("error", function (e) {
      try {
        if (e && e.target && e.target !== window) return;
        jsError("error", shortMsg(e && e.message), fileOf(e && e.filename), e && e.lineno);
      } catch (x) {}
    });
    window.addEventListener("error", function (e) {
      try {
        var el = e && e.target;
        if (!el || el === window || !el.tagName) return;
        var tag = el.tagName.toLowerCase();
        if (tag !== "script" && tag !== "img" && !(tag === "link" && /stylesheet/i.test(el.rel || ""))) return;
        jsError("resource", tag + "_load_failed", fileOf(el.currentSrc || el.src || el.href), 0);
      } catch (x) {}
    }, true);
    window.addEventListener("unhandledrejection", function (e) {
      try {
        var r = e && e.reason;
        var at = r && r.stack ? String(r.stack).match(/(https?:\/\/[^\s()]+?):(\d+):\d+/) : null;
        jsError("rejection", shortMsg(r && r.message != null ? r.message : r), at ? fileOf(at[1]) : "none", at ? at[2] : 0);
      } catch (x) {}
    });
  } catch (e) {}

  /* Which app's browser this is, from the user agent of this (top) frame. */
  var DEVICE = (function () {
    var ua = "";
    try { ua = String(navigator.userAgent || ""); } catch (e) {}
    function has(s) { return ua.indexOf(s) > -1; }
    var app = "none";
    if (has("Instagram")) app = "ig";
    else if (has("MessengerForiOS") || has("Orca-Android")) app = "messenger";
    else if (has("FBAN") || has("FBAV") || has("FB_IAB") || has("FB4A") || has("FBIOS")) app = "fb";
    else if (has("; wv)")) app = "other_inapp";
    var os = /iPhone|iPad|iPod/.test(ua) ? "ios" : has("Android") ? "android" : "other";
    return { app: app, os: os, wv: has("; wv)") };
  })();

  /* ---------- In-app checkout (2026-10-04e) ----------
     Only in the Facebook, Instagram and Messenger browsers (DEVICE.app fb, ig,
     messenger). Safari, Chrome and every other browser keep the old path.
     Landing-funnel/CHECKOUT-DEEP-DIVE-2026-10-04.md fixes 1, 2 and 4:
     1) Checkout goes to /checkout?skip_shop_pay=true, which skips the shop.app
        hop and lands on our own checkout, where the pixel, Abandoned checkouts
        and the reminder email work. The drawer link, the offer links and the
        cart page Checkout buttons get the parameter in the capture phase, before
        the browser acts on the tap: nothing waits and nothing is cancelled.
        Other query parts stay, and a code on the cart stays on the cart. The
        cart page form posts to /cart?skip_shop_pay=true, which saves the
        quantities and goes straight to our checkout (curl check, 2026-10-04).
     2) The drawer draws no express wallet row (setExpress, loadExpress).
     3) jeriack_checkout_left (watchCheckout, checkoutLeft). */
  var INAPP = DEVICE.app === "fb" || DEVICE.app === "ig" || DEVICE.app === "messenger";

  /* Same-site URL with skip_shop_pay=true, as a path. "" for another site. */
  function skipShopPay(u) {
    try {
      var url = new URL(u, location.href);
      if (url.origin !== location.origin) return "";
      url.searchParams.set("skip_shop_pay", "true");
      return url.pathname + url.search + url.hash;
    } catch (e) { return ""; }
  }

  /* A Checkout submit button gets a formaction, a link to /checkout gets a new href. */
  function inappCheckoutUrl(el) {
    try {
      var tag = el.tagName;
      if ((tag === "BUTTON" || tag === "INPUT") && el.name === "checkout" && el.type === "submit") {
        if (!el.form) return;
        var to = skipShopPay(el.getAttribute("formaction") || el.form.getAttribute("action") || "/cart");
        if (to) el.setAttribute("formaction", to);
      } else if (tag === "A" && /\/checkout\/?$/.test(el.pathname || "")) {
        var href = skipShopPay(el.href);
        if (href) el.setAttribute("href", href);
      }
    } catch (e) {}
  }

  if (INAPP) {
    try {
      /* Registered before the tap listener below, so it runs first. Never cancels the tap. */
      document.addEventListener("click", function (e) {
        try {
          var el = e.target && e.target.closest ? e.target.closest("a[href], button[name=checkout], input[name=checkout]") : null;
          if (el) inappCheckoutUrl(el);
        } catch (x) {}
      }, true);
      /* Enter in a field submits without a click; browsers read the action after this event. */
      document.addEventListener("submit", function (e) {
        try { if (e.submitter) inappCheckoutUrl(e.submitter); } catch (x) {}
      }, true);
    } catch (e) {}
  }

  /* Measured after window load plus one frame: at DOMContentLoaded the product
     page reported a zoomed-out viewport (442x813 on a 375x690 screen). vw and vh
     are the layout viewport (clientWidth/clientHeight), innerWidth as a fallback. */
  function sendDevice() {
    var done = false;
    function send() {
      if (done) return;
      done = true;
      try {
        var de = document.documentElement || {};
        trackCapped("jeriack_device", {
          app: DEVICE.app, os: DEVICE.os, wv: DEVICE.wv,
          vw: de.clientWidth || window.innerWidth || 0, vh: de.clientHeight || window.innerHeight || 0,
          sw: (window.screen && screen.width) || 0, page: pageType()
        }, 1);
      } catch (e) {}
    }
    function later() {
      try { requestAnimationFrame(function () { setTimeout(send, 0); }); } catch (e) {}
      setTimeout(send, 1000);   /* no frames while the page is hidden */
    }
    try {
      if (document.readyState === "complete") later();
      else window.addEventListener("load", later);
      /* A shopper who leaves before load still counts. */
      window.addEventListener("pagehide", send);
      document.addEventListener("visibilitychange", function () {
        if (document.visibilityState === "hidden") send();
      });
    } catch (e) {}
  }

  /* what: add, cart, change, express_section. status 0 = no network. */
  function fetchFail(what, status) {
    try { trackCapped("jeriack_fetch_fail", { what: what, status: Number(status) || 0, page: pageType() }, 5); } catch (e) {}
  }

  /* Shopify's wallet elements (portable-wallets.en.js), checked on the dev theme
     2026-10-04. Buy it now is the product page fallback, not a wallet. */
  var WALLET_TAGS = {
    "shop-pay-wallet-button": "shoppay",
    "shopify-paypal-button": "paypal",
    "shopify-google-pay-button": "gpay",
    "shopify-apple-pay-button": "applepay",
    "shopify-buy-it-now-button": "buynow"
  };
  var WALLET_SEL = Object.keys(WALLET_TAGS).join(",");
  var WALLET_HOLDERS = "[data-drawer-express-buttons], .cartpage__express, .product__express, " +
    "shopify-accelerated-checkout, shopify-accelerated-checkout-cart";

  function walletOf(el) {
    try {
      var w = el && el.closest ? el.closest(WALLET_SEL) : null;
      return w ? WALLET_TAGS[w.tagName.toLowerCase()] : "unknown";
    } catch (e) { return "unknown"; }
  }

  /* A wallet has drawn once its element is defined and takes up space. */
  function walletScan(holder) {
    var out = { present: 0, drawnCount: 0, codes: [] };
    if (!holder) return out;
    var els = holder.querySelectorAll(WALLET_SEL);
    out.present = els.length;
    for (var i = 0; i < els.length; i++) {
      var tag = els[i].tagName.toLowerCase();
      if (window.customElements && customElements.get(tag) && els[i].getBoundingClientRect().height > 0) {
        out.drawnCount++;
        if (out.codes.indexOf(WALLET_TAGS[tag]) < 0) out.codes.push(WALLET_TAGS[tag]);
      }
    }
    return out;
  }

  /* jeriack_express_status. Polls every 250 ms for up to 6 s. fail = a state
     known up front (fetch_failed, no_section). atEnd = report at the 6 s mark
     only (cart and product pages), otherwise report once every wallet in the
     holder has drawn and the set has held for 500 ms, since Shopify can add the
     wallets one at a time (drawer). liveFn (drawer only) turns false when this
     open ends: the hidden drawer measures every wallet at 0 px, so the status
     is sent then, as ready if the wallets had settled, otherwise as closed.
     wallets lists every wallet seen drawn during the poll. */
  function expressStatus(area, holderFn, ceTag, fail, t0, atEnd, liveFn) {
    var first = 0, seen = [], settledAt = 0, settledCount = 0;
    function finish(state, codes) {
      var d = { area: area, state: state, wallets: codes.length ? codes.join("-") : "none" };
      if (first) d.ms = first - t0;
      trackCapped("jeriack_express_status", d, 10);
    }
    try {
      if (fail) { finish(fail, []); return; }
      (function poll() {
        try {
          if (liveFn && !liveFn()) { finish(settledAt ? "ready" : "closed", seen); return; }
          var w = walletScan(holderFn());
          if (w.drawnCount && !first) first = Date.now();
          w.codes.forEach(function (c) { if (seen.indexOf(c) < 0) seen.push(c); });
          var settled = w.present > 0 && w.drawnCount === w.present;
          if (!settled) { settledAt = 0; settledCount = 0; }
          else if (w.present !== settledCount) { settledAt = Date.now(); settledCount = w.present; }
          if (!atEnd && settledAt && Date.now() - settledAt >= 500) { finish("ready", seen); return; }
          if (Date.now() - t0 >= 6000) {
            if (seen.length) finish("ready", seen);
            else if (!(window.customElements && customElements.get(ceTag))) finish("not_defined", []);
            else finish("timeout", []);
            return;
          }
          setTimeout(poll, 250);
        } catch (x) {}
      })();
    } catch (e) {}
  }

  /* Checkout taps: if the page is still showing 4 s and 10 s later, the handoff
     is slow or stuck. Leaving the page (pagehide or hidden) cancels both. */
  var stuckTimers = [];
  function cancelStuck() {
    try { stuckTimers.forEach(clearTimeout); } catch (e) {}
    stuckTimers = [];
  }
  /* jeriack_checkout_left (in-app browsers only): the page was hidden or unloaded
     within 10 s of a Checkout tap, so the tap did leave the page. Once per tap.
     Read with checkout_started: left without it means checkout opened but went
     untracked, or the shopper closed it; neither means a dead tap (that is stuck). */
  var leftTap = null;
  function checkoutLeft() {
    try {
      var t = leftTap;
      if (!t || t.sent || t.ev.defaultPrevented) return;
      var ms = Date.now() - t.at;
      if (ms > 10000) return;
      t.sent = true;
      trackCapped("jeriack_checkout_left", { from: t.from, seconds: Math.round(ms / 100) / 10, app: DEVICE.app, os: DEVICE.os }, 6);
    } catch (e) {}
  }
  function checkoutFrom(el) {
    if (el.matches("[data-drawer-checkout]")) return "drawer";
    if (el.matches("button[name=checkout]")) return "cart_page";
    if (el.matches("[data-ob-checkout], [data-ob-barcheckout]")) return "offer";
    return "";
  }
  function watchCheckout(el, ev) {
    var from = checkoutFrom(el);
    if (!from) return;
    /* A cmd, ctrl or shift tap opens checkout in another tab or window, so this
       page staying visible is normal. */
    if (ev.metaKey || ev.ctrlKey || ev.shiftKey || (ev.button && ev.button !== 0)) return;
    /* The browser's own form check (for example a bad quantity) stops the submit
       without setting defaultPrevented. :invalid reads it without firing events. */
    try {
      var form = el.form;
      if (form && !form.noValidate && !el.formNoValidate && form.matches(":invalid")) return;
    } catch (x) {}
    cancelStuck();
    if (INAPP) leftTap = { from: from, at: Date.now(), ev: ev, sent: false };
    [4, 10].forEach(function (s) {
      stuckTimers.push(setTimeout(function () {
        try {
          /* A tap another script cancelled (for example a locked offer button) is not a handoff. */
          if (ev.defaultPrevented || document.visibilityState !== "visible") return;
          trackCapped("jeriack_checkout_stuck", { from: from, waited: s, online: navigator.onLine !== false }, 6);
        } catch (x) {}
      }, s * 1000));
    });
  }

  function slug(s) {
    return String(s || "").toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "").slice(0, 24);
  }
  function buttonCode(el) {
    var t = el.getAttribute("data-track");
    if (t) return slug(t);
    if (el.querySelector && el.querySelector("[data-cart-count]")) return "cart";   /* the header link, without its count */
    var href = el.getAttribute("href") || "";
    if (/^mailto:/i.test(href)) return "email_link";
    if (/^tel:/i.test(href)) return "phone_link";
    var img = el.querySelector && el.querySelector("img[alt]");
    var raw = el.getAttribute("aria-label") || (el.textContent || "").trim() || el.value || el.title || (img ? img.alt : "");
    raw = String(raw || "");
    /* Never an email address or a long number. */
    if (raw.indexOf("@") > -1 || /\d{6,}/.test(raw.replace(/[\s().-]/g, ""))) return el.tagName.toLowerCase();
    return slug(raw) || el.tagName.toLowerCase();
  }
  function areaOf(el) {
    if (el.closest(".cart-drawer")) return "drawer";
    if (el.closest("[data-ob], [data-offer]")) return "offer";
    if (el.closest("[data-cart-page]")) return "cart_page";
    if (el.closest(".site-header")) return "header";
    if (el.closest(".product")) return "product";
    return "other";
  }

  var lastTap = { key: "", at: 0 };
  var tapPerKey = {};   /* at most 5 rows per area|button per page view, so one busy button cannot use up the 40 */
  try {
    /* One listener for every tap, in the capture phase so nothing can hide a tap
       from it. It only reads, it never cancels or delays the tap. */
    document.addEventListener("click", function (e) {
      try {
        var el = e.target && e.target.closest ? e.target.closest("button, a[href], [role=button], input[type=submit]") : null;
        if (!el) return;
        watchCheckout(el, e);
        if (el.closest(WALLET_HOLDERS)) return;   /* the express events cover wallet taps */
        if (el.closest("[data-ob-stage]")) return;   /* the dunk game, covered by jeriack_game_dunk */
        var area = areaOf(el), code = buttonCode(el), key = area + "|" + code, now = Date.now();
        if (key === lastTap.key && now - lastTap.at < 400) return;
        lastTap = { key: key, at: now };
        tapPerKey[key] = (tapPerKey[key] || 0) + 1;
        if (tapPerKey[key] > 5) return;
        var d = { area: area, button: code };
        if (area === "drawer") d.seconds_open = secondsOpen();
        trackCapped("jeriack_tap", d, 40);
      } catch (x) {}
    }, true);
    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "hidden") { checkoutLeft(); cancelStuck(); }
    });
    window.addEventListener("pagehide", function () { checkoutLeft(); cancelStuck(); });
  } catch (e) {}

  /* Express status on the cart page and the product page, once, 6 s after load. */
  function pageExpressStatus() {
    try {
      var t0 = Date.now();
      var kind = pageType();
      if (kind === "cart" && document.querySelector("[data-cart-page] [data-cart-items]")) {
        expressStatus("cart_page", function () { return document.querySelector(".cartpage__express"); },
          "shopify-accelerated-checkout-cart", document.querySelector(".cartpage__express") ? "" : "no_section", t0, true);
      } else if (kind === "product") {
        expressStatus("product", function () { return document.querySelector(".product__express"); },
          "shopify-accelerated-checkout", document.querySelector(".product__express") ? "" : "no_section", t0, true);
      }
    } catch (e) {}
  }

  /* Duplicate marquee tracks so the -50% translate loops seamlessly. */
  function primeMarquees() {
    document.querySelectorAll("[data-marquee]").forEach(function (track) {
      if (track.dataset.primed) return;
      track.innerHTML += track.innerHTML;
      track.dataset.primed = "true";
    });
  }

  /* ---------- Cart drawer ----------
     After Add to cart the cart slides in, so shoppers can add more boxes,
     change quantities, or go to checkout without leaving the page. The
     /cart page still works as the no-JavaScript fallback. */
  var drawer = null;
  var lastFocus = null;
  var isOpen = false;
  var lastCart = null;
  var openedAt = 0;      /* when this open started, for seconds_open */
  var leftDone = false;  /* this open already went somewhere (checkout, View cart, a link) */
  var leftSent = false;  /* this open already sent left_site (once per open, also after an express tap) */
  var expressDone = false;   /* an express wallet was tapped during this open */
  var expressShown = false;  /* the express buttons were drawn during this open */
  var scrollMax = 0;         /* furthest scroll of the drawer body during this open, px */
  var hiddenSinceTap = false;
  var expressCheckTimer = 0;
  var expressAt = 0;
  var expressSeq = 0;
  var openSeq = 0;           /* counts opens, so a drawer express_status can tell its open has ended */
  var EXPRESS_SECTION = "cart-drawer-express";
  var LOCK_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" ' +
    'stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="4" y="11" width="16" height="10" rx="2"/>' +
    '<path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>';
  var CHECK_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" ' +
    'stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  /* Free with every order: one fixed line plus its quantity line, above the proof strip, no choices.
     The product page and the cart page show the same copy (snippets/bonus-kit.liquid).
     Quantities only, never a dollar value.
     The cover sits next to this file in the theme assets. */
  var BOOK_COVER = (function () {
    try {
      var src = document.currentScript && document.currentScript.src;
      var re = /\/theme\.js(\?.*)?$/;
      return src && re.test(src) ? src.replace(re, "/bonus-kit-cover.jpg?width=96") : "";
    } catch (e) { return ""; }
  })();

  function bookHtml() {
    return '<p class="cart-drawer__book" data-drawer-book hidden>' +
      (BOOK_COVER ? '<img class="cart-drawer__book-cover" src="' + esc(BOOK_COVER) + '" alt="" width="40" height="52" loading="lazy">' : "") +
      '<span class="cart-drawer__book-text">' +
        "<span><strong>Free with your order:</strong> The Coffee Break Book</span>" +
        '<span class="cart-drawer__book-sub"><span>24 cookie recipes,</span> <span>12 large-print</span> puzzles</span>' +
      "</span>" +
    "</p>";
  }

  /* Drawer events for the journey dashboard. Shopify passes custom events to
     our custom pixel, which stores jeriack_* events and never sends them to
     Meta. Totals are in dollars. */
  function track(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === "function") {
        Shopify.analytics.publish(name, data || {});
      }
    } catch (e) {}
  }

  function secondsOpen() {
    return openedAt ? Math.round((Date.now() - openedAt) / 1000) : 0;
  }

  function cartFacts() {
    var c = lastCart || { item_count: 0, total_price: 0 };
    return { item_count: c.item_count, total: c.total_price / 100, seconds_open: secondsOpen() };
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat("en-US", { style: "currency", currency: currency || "USD" }).format(cents / 100);
    } catch (e) {
      return "$" + (cents / 100).toFixed(2);
    }
  }

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function updateCount(cart) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = cart.item_count;
    });
  }

  function buildDrawer() {
    if (drawer) return drawer;
    drawer = document.createElement("div");
    drawer.className = "cart-drawer";
    drawer.hidden = true;
    /* The lines, the proof strip and express pay scroll together; the totals
       and Checkout stay pinned at the bottom. data-drawer-close names how the
       drawer was closed, for the close event. */
    drawer.innerHTML =
      '<div class="cart-drawer__overlay" data-drawer-close="overlay"></div>' +
      '<aside class="cart-drawer__panel" role="dialog" aria-modal="true" aria-labelledby="cart-drawer-title" tabindex="-1">' +
        '<header class="cart-drawer__head">' +
          '<h2 class="cart-drawer__title" id="cart-drawer-title">Your cart</h2>' +
          '<button type="button" class="cart-drawer__close" data-drawer-close="close_button" data-track="close_cart" aria-label="Close cart">&times;</button>' +
        '</header>' +
        '<p class="cart-drawer__notice" data-drawer-notice role="status" hidden></p>' +
        '<div class="cart-drawer__body">' +
          '<div class="cart-drawer__items" data-drawer-items></div>' +
          bookHtml() +
          '<ul class="cart-drawer__proof" data-drawer-proof role="list" hidden>' +
            "<li>" + CHECK_ICON + "<span>8g protein, 13 vitamins and minerals, 150 calories per cookie</span></li>" +
            "<li>" + CHECK_ICON + "<span>Doctor formulated</span></li>" +
            "<li>" + CHECK_ICON + "<span>Free shipping on every order, no code needed</span></li>" +
          "</ul>" +
          '<div class="cart-drawer__express" data-drawer-express hidden>' +
            '<p class="cart-drawer__express-label">Express checkout</p>' +
            "<div data-drawer-express-buttons></div>" +
          "</div>" +
        "</div>" +
        '<footer class="cart-drawer__foot" data-drawer-foot>' +
          '<div class="cart-drawer__discounts" data-drawer-discounts hidden></div>' +
          '<div class="cart-drawer__total"><span>Total</span>' +
            '<span><del class="cart-drawer__was" data-drawer-was hidden></del><strong data-drawer-total></strong></span>' +
          '</div>' +
          '<p class="cart-drawer__ship"><strong>Shipping: Free</strong><span>Tax, if any, at checkout</span></p>' +
          '<a class="btn btn--dark cart-drawer__checkout" href="' + (INAPP ? "/checkout?skip_shop_pay=true" : "/checkout") +
            '" data-drawer-checkout data-track="checkout">' + LOCK_ICON + "Checkout</a>" +
          '<div class="cart-drawer__links">' +
            '<button type="button" data-drawer-close="keep_shopping" data-track="keep_shopping">Keep shopping</button>' +
            '<a href="/cart" data-drawer-view-cart data-track="view_cart">View cart</a>' +
          '</div>' +
        '</footer>' +
      '</aside>';
    document.body.appendChild(drawer);

    drawer.addEventListener("click", function (e) {
      var close = e.target.closest("[data-drawer-close]");
      if (close) { closeDrawer(close.getAttribute("data-drawer-close")); return; }
      var checkout = e.target.closest("[data-drawer-checkout]");
      if (checkout) {
        leftDone = true;
        track("jeriack_drawer_checkout", cartFacts());
        return;
      }
      if (e.target.closest("[data-drawer-view-cart]")) { leftDone = true; track("jeriack_drawer_view_cart", cartFacts()); return; }
      if (e.target.closest("[data-drawer-express-buttons]")) { expressTap(walletOf(e.target), "tap"); return; }
      if (e.target.closest("a[href]")) { leftDone = true; return; } /* a product link, still on the site */
      var btn = e.target.closest("[data-line-qty]");
      if (btn) {
        changeLine(btn.getAttribute("data-key"), parseInt(btn.getAttribute("data-line-qty"), 10),
          btn.getAttribute("data-action"), btn.getAttribute("data-variant"));
      }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && isOpen) closeDrawer("escape");
    });

    /* PayPal draws its button inside a frame, and taps in a frame never reach
       the page. The page loses focus to that frame instead. */
    window.addEventListener("blur", function () {
      setTimeout(function () {
        var holder = drawer.querySelector("[data-drawer-express-buttons]");
        var active = document.activeElement;
        if (isOpen && holder.contains(active)) expressTap(walletOf(active), "frame_focus");
      }, 0);
    });

    /* Furthest scroll of the drawer body, for the close and left_site events. */
    try {
      drawer.querySelector(".cart-drawer__body").addEventListener("scroll", function (e) {
        var top = e.currentTarget.scrollTop;
        if (top > scrollMax) scrollMax = top;
      }, { passive: true });
    } catch (e) {}

    /* The page was hidden with the drawer open (another app or tab, or the
       browser closed), once per open. Checkout, View cart and links do not
       count; an express tap does, with after=express. */
    function leftSite() {
      hiddenSinceTap = true;
      if (!isOpen || leftDone || leftSent) return;
      leftSent = true;
      track("jeriack_drawer_left_site", { seconds_open: secondsOpen(), after: expressDone ? "express" : "none", scroll_px: Math.round(scrollMax) });
    }
    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "hidden") leftSite();
    });
    window.addEventListener("pagehide", leftSite);
    return drawer;
  }

  /* One event per tap, even when both the click and the frame focus see it.
     6 s later, express_check says whether anything opened: hidden=false with
     drawer_open=true means the tap went nowhere. */
  function expressTap(wallet, via) {
    if (Date.now() - expressAt < 2000) return;
    expressAt = Date.now();
    expressDone = true;
    hiddenSinceTap = false;
    var facts = cartFacts();
    facts.wallet = wallet || "unknown";
    facts.via = via;
    trackCapped("jeriack_drawer_express", facts, 10);
    clearTimeout(expressCheckTimer);
    expressCheckTimer = setTimeout(function () {
      try {
        trackCapped("jeriack_express_check", {
          wallet: facts.wallet, hidden: hiddenSinceTap,
          focus: typeof document.hasFocus === "function" ? document.hasFocus() : true, drawer_open: isOpen
        }, 10);
      } catch (e) {}
    }, 6000);
  }

  /* Called when a new open starts. */
  function beginOpen() {
    openSeq++;
    leftDone = false;
    leftSent = false;
    expressDone = false;
    try {
      var d = buildDrawer();
      expressShown = false;   /* set by setExpress once this open's buttons are drawn */
      scrollMax = d.querySelector(".cart-drawer__body").scrollTop || 0;
    } catch (e) { scrollMax = 0; }
  }

  /* The open event waits one frame, so it can say whether Checkout is on screen. */
  function openEvent(trigger, cart) {
    var data = {
      trigger: trigger || "other", item_count: cart.item_count, total: cart.total_price / 100,
      vh: window.innerHeight || 0, checkout_visible: false, app: DEVICE.app, os: DEVICE.os
    };
    var done = false;
    function send() {
      if (done) return;
      done = true;
      try {
        var b = drawer && drawer.querySelector("[data-drawer-checkout]");
        var r = b && b.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight || 0;
        data.vh = vh;
        data.checkout_visible = !!(r && r.height > 0 && r.bottom > 0 && r.bottom <= vh);
      } catch (e) {}
      track("jeriack_drawer_open", data);
    }
    try { requestAnimationFrame(send); } catch (e) {}
    setTimeout(send, 250);   /* no frames while the page is hidden */
  }

  /* Express pay (Shop Pay, PayPal, Apple Pay, Google Pay). Shopify renders the
     buttons in the cart-drawer-express section, fetched with the Section
     Rendering API, which is how Shopify supports them in a cart drawer. With no
     section or no express methods, nothing shows. */
  function setExpress(html) {
    var box = buildDrawer().querySelector("[data-drawer-express]");
    /* In-app browsers: no wallet row, so no wallet script loads and Checkout is the one big button. */
    if (INAPP) {
      box.querySelector("[data-drawer-express-buttons]").innerHTML = "";
      box.hidden = true;
      return false;
    }
    var src = html ? new DOMParser().parseFromString(html, "text/html").querySelector("[data-express-src]") : null;
    var ok = !!(src && src.querySelector("shopify-accelerated-checkout-cart") && lastCart && lastCart.item_count);
    box.querySelector("[data-drawer-express-buttons]").innerHTML = ok ? src.innerHTML : "";
    box.hidden = !ok;
    if (ok && isOpen) expressShown = true;
    /* Pages without a buy button have not loaded Shopify's wallet script yet. */
    if (ok && window.customElements && !customElements.get("shopify-accelerated-checkout-cart") &&
        window.Shopify && Shopify.PaymentButton && typeof Shopify.PaymentButton.init === "function") {
      Shopify.PaymentButton.init();
    }
    return ok;
  }

  /* withStatus: this load belongs to a new open, so it sends express_status. A
     failed fetch keeps its reason (fetch_failed) instead of becoming an empty
     string, so the status can tell it apart from a missing section. */
  function loadExpress(withStatus) {
    var seq = ++expressSeq;
    var t0 = Date.now();
    var fail = "";
    var mine = openSeq;
    if (INAPP) {
      /* Nothing to fetch in these apps (see setExpress). One status per open says why. */
      setExpress("");
      if (withStatus) expressStatus("drawer", function () { return null; }, "shopify-accelerated-checkout-cart", "inapp_off", t0, false);
      return;
    }
    fetch("/cart?section_id=" + EXPRESS_SECTION)
      .then(function (r) {
        if (r.ok) return r.text();
        fail = "fetch_failed";
        fetchFail("express_section", r.status);
        return "";
      })
      .catch(function () {
        if (!fail) { fail = "fetch_failed"; fetchFail("express_section", 0); }
        return "";
      })
      .then(function (html) {
        /* A newer load or a quantity change may have drawn the buttons already. */
        var ok = seq === expressSeq ? setExpress(html) : null;
        if (withStatus) {
          expressStatus("drawer", function () { return drawer && drawer.querySelector("[data-drawer-express-buttons]"); },
            "shopify-accelerated-checkout-cart", fail || (ok === false ? "no_section" : ""), t0, false,
            function () { return isOpen && openSeq === mine; });
        }
      })
      .catch(function () {});
  }

  function lineHtml(item, currency) {
    var img = item.image
      ? '<img class="cart-line__img" src="' + esc(item.image + (item.image.indexOf("?") > -1 ? "&" : "?") + "width=160") +
        '" alt="" width="72" height="72" loading="lazy">'
      : '<span class="cart-line__img"></span>';
    var variant = item.variant_title ? '<span class="cart-line__variant">' + esc(item.variant_title) + "</span>" : "";
    var key = 'data-key="' + esc(item.key) + '" data-variant="' + esc(item.variant_id) + '"';
    /* Stepper and Remove share one row under the title, which keeps the proof
       strip and the total on the first screen of a phone. */
    return '<div class="cart-line">' + img +
      '<div class="cart-line__info">' +
        '<a class="cart-line__title" href="' + esc(item.url) + '" data-track="line_title">' + esc(item.product_title) + "</a>" + variant +
      "</div>" +
      '<div class="cart-line__price">' + money(item.final_line_price, currency) + "</div>" +
      '<div class="cart-line__controls">' +
        '<div class="cart-line__qty">' +
          '<button type="button" ' + key + ' data-action="minus" data-track="minus" data-line-qty="' + (item.quantity - 1) + '" aria-label="One fewer"' +
            (item.quantity <= 1 ? " disabled" : "") + ">&minus;</button>" +
          "<span>" + item.quantity + "</span>" +
          '<button type="button" ' + key + ' data-action="plus" data-track="plus" data-line-qty="' + (item.quantity + 1) + '" aria-label="One more">+</button>' +
        "</div>" +
        '<button type="button" class="cart-line__remove" ' + key + ' data-action="remove" data-track="remove" data-line-qty="0">Remove</button>' +
      "</div>" +
    "</div>";
  }

  function renderCart(cart) {
    var d = buildDrawer();
    var list = d.querySelector("[data-drawer-items]");
    var empty = !cart.items.length;
    lastCart = cart;
    if (empty) {
      list.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
      d.querySelector("[data-drawer-express]").hidden = true;
    } else {
      list.innerHTML = cart.items.map(function (item) { return lineHtml(item, cart.currency); }).join("");
    }
    d.querySelector("[data-drawer-foot]").hidden = empty;
    d.querySelector("[data-drawer-book]").hidden = empty;
    d.querySelector("[data-drawer-proof]").hidden = empty;
    renderDiscounts(d, cart);
    d.querySelector("[data-drawer-total]").textContent = money(cart.total_price, cart.currency);
    updateCount(cart);
    /* Scripts on the page (assets/coffee-break.js, the offer pages) follow the cart. */
    try { document.dispatchEvent(new CustomEvent("jeriack:cart", { detail: cart })); } catch (e) {}
  }

  /* A code on the whole order (for example COMEBACK20) arrives as a cart level
     application. A code on products only lowers the lines, so it is found in
     the line allocations. Subtotal shows the discounted total, with the
     price before the discount struck through. */
  function renderDiscounts(d, cart) {
    var rows = [];
    /* The price drop (2026-10-16) as a row like a discount code: compare-at minus the price, per line
       (window.jxCompare from snippets/dunk-data.liquid). It is not a discount on the order, so it only
       adds to what was saved and to the struck total; the total itself is already the lower price. */
    var cmp = window.jxCompare || {};
    var dropAmount = 0;
    cart.items.forEach(function (item) {
      var c = cmp[String(item.variant_id)];
      if (c && c > item.original_price) dropAmount += (c - item.original_price) * item.quantity;
    });
    if (dropAmount > 0) rows.push({ title: window.jxDealLine || "Sale price", amount: dropAmount, drop: true });
    (cart.cart_level_discount_applications || []).forEach(function (app) {
      if (app.total_allocated_amount > 0) rows.push({ title: app.title, amount: app.total_allocated_amount });
    });
    var lineTitles = {};
    var lineAmount = 0;
    cart.items.forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (a) {
        lineAmount += a.amount;
        if (a.discount_application && a.discount_application.title) lineTitles[a.discount_application.title] = true;
      });
    });
    if (lineAmount > 0) rows.push({ title: Object.keys(lineTitles).join(", "), amount: lineAmount });
    if (rows.length === (dropAmount > 0 ? 1 : 0) && cart.total_discount > 0) rows.push({ title: "", amount: cart.total_discount });

    var saved = rows.reduce(function (sum, r) { return sum + r.amount; }, 0);
    var box = d.querySelector("[data-drawer-discounts]");
    box.innerHTML = rows.map(function (r) {
      if (r.drop) {
        return '<div class="cart-drawer__discount"><span>' + esc(r.title) + "</span>" +
          "<span>&minus;" + money(r.amount, cart.currency) + "</span></div>";
      }
      return '<div class="cart-drawer__discount"><span>Discount' + (r.title ? " (" + esc(r.title) + ")" : "") + "</span>" +
        "<span>&minus;" + money(r.amount, cart.currency) + "</span></div>";
    }).join("");
    box.hidden = !rows.length || !cart.items.length;

    var was = d.querySelector("[data-drawer-was]");
    var before = Math.max(cart.items_subtotal_price || 0, cart.total_price + saved);
    was.hidden = !(saved > 0 && before > cart.total_price);
    was.innerHTML = was.hidden ? "" : '<span class="visually-hidden">Was </span>' + money(before, cart.currency);
  }

  function openDrawer(notice) {
    var d = buildDrawer();
    var n = d.querySelector("[data-drawer-notice]");
    n.hidden = !notice;
    n.textContent = notice || "";
    if (d.hidden) lastFocus = document.activeElement;
    d.hidden = false;
    isOpen = true;
    document.documentElement.classList.add("cart-drawer-open");
    requestAnimationFrame(function () {
      d.classList.add("is-open");
      d.querySelector(".cart-drawer__panel").focus();
    });
  }

  function closeDrawer(method) {
    if (!drawer || !isOpen) return;
    isOpen = false;
    track("jeriack_drawer_close", {
      method: method || "other", seconds_open: secondsOpen(), scroll_px: Math.round(scrollMax), express_shown: expressShown
    });
    openedAt = 0;
    drawer.classList.remove("is-open");
    document.documentElement.classList.remove("cart-drawer-open");
    /* Reopened within the slide-out? Then stay visible. */
    setTimeout(function () { if (!isOpen) drawer.hidden = true; }, 250);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* trigger says what opened it: add_to_cart, header, or back (the page came
     back from the browser cache with the drawer still open). */
  function loadAndOpen(notice, trigger) {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) {
        if (!r.ok) { fetchFail("cart", r.status); throw new Error("cart failed"); }
        return r.json();
      }, function (err) { fetchFail("cart", 0); throw err; })
      .then(function (cart) {
        var opening = !isOpen || trigger === "back";
        renderCart(cart);
        openDrawer(notice);
        if (opening) {
          openedAt = Date.now();
          beginOpen();
        }
        if (cart.item_count) loadExpress(opening);
        if (opening) openEvent(trigger, cart);
      });
  }

  function changeLine(key, qty, action, variant) {
    var panel = buildDrawer().querySelector(".cart-drawer__panel");
    panel.classList.add("is-busy");
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      /* The express buttons come back in the same reply, for the new total. In-app browsers draw
         no wallet row, so they do not ask for that section. */
      body: JSON.stringify(INAPP ? { id: key, quantity: Math.max(0, qty) }
        : { id: key, quantity: Math.max(0, qty), sections: EXPRESS_SECTION, sections_url: "/cart" })
    })
      .then(function (r) {
        if (!r.ok) { fetchFail("change", r.status); throw new Error("change failed"); }
        return r.json();
      }, function (err) { fetchFail("change", 0); throw err; })
      .then(function (cart) {
        renderCart(cart);
        buildDrawer().querySelector("[data-drawer-notice]").hidden = true;
        var line = cart.items.filter(function (item) { return item.key === key; })[0];
        track("jeriack_drawer_qty", { action: action || "other", variant_id: Number(variant) || null, new_qty: line ? line.quantity : 0 });
        expressSeq++;
        setExpress(cart.sections && cart.sections[EXPRESS_SECTION]);
      })
      .catch(function () { window.location.href = "/cart"; })
      .then(function () { panel.classList.remove("is-busy"); });
  }

  /* Show Shopify's reason (for example a quantity limit) under the form. */
  function showFormError(form, message) {
    var el = form.querySelector(".product__error");
    if (!el) {
      el = document.createElement("p");
      el.className = "product__error";
      el.setAttribute("role", "alert");
      form.appendChild(el);
    }
    el.textContent = message || "Sorry, that could not be added. Please try again.";
  }

  function wireAddToCart() {
    document.querySelectorAll("form[action$='/cart/add']").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        if (form.dataset.noajax) return;
        e.preventDefault();
        var btn = form.querySelector("[type='submit']");
        var label = btn ? btn.textContent : "";
        var reset = function () { if (btn) { btn.disabled = false; btn.textContent = label; } };
        if (btn) { btn.disabled = true; btn.textContent = "Adding…"; }
        var old = form.querySelector(".product__error");
        if (old) old.remove();

        fetch("/cart/add.js", {
          method: "POST",
          headers: { Accept: "application/json" },
          body: new FormData(form)
        }).then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (body) {
            reset();
            if (!r.ok) { fetchFail("add", r.status); showFormError(form, body.description || body.message); return; }
            /* The item is in the cart now. If the drawer can't load, show the cart page. */
            return loadAndOpen("Added to your cart ✓", "add_to_cart").catch(function () { window.location.href = "/cart"; });
          });
        }, function () {
          /* Network trouble before anything was added: fall back to a normal post. */
          fetchFail("add", 0);
          reset();
          form.dataset.noajax = "true";
          form.submit();
        });
      });
    });

    /* The header Cart link opens the drawer too. Modifier clicks still open /cart,
       and on the cart page itself the link just reloads it. */
    document.querySelectorAll(".header-cart").forEach(function (link) {
      link.addEventListener("click", function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        if (document.querySelector("[data-cart-page]")) return;
        e.preventDefault();
        loadAndOpen(null, "header").catch(function () { window.location.href = link.href; });
      });
    });

    /* Returning with Back can restore the page from cache; refresh an open drawer. */
    window.addEventListener("pageshow", function (e) {
      if (e.persisted && isOpen) loadAndOpen(null, "back");
    });
  }

  /* Quantity steppers (− / +). */
  function wireQuantity() {
    document.querySelectorAll("[data-qty]").forEach(function (wrap) {
      var input = wrap.querySelector("input");
      if (!input) return;
      wrap.querySelectorAll("button").forEach(function (b) {
        b.addEventListener("click", function () {
          var step = b.dataset.step === "down" ? -1 : 1;
          var min = parseInt(input.getAttribute("min"), 10);
          if (isNaN(min)) min = 1;
          var val = Math.max(min, (parseInt(input.value, 10) || min) + step);
          input.value = val;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });
    });
  }

  /* Product gallery: click a thumb to swap the main image. */
  function wireGallery() {
    document.querySelectorAll("[data-gallery]").forEach(function (gallery) {
      var main = gallery.querySelector("[data-gallery-main]");
      gallery.querySelectorAll("[data-thumb]").forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          var full = thumb.getAttribute("data-full");
          /* The main image has a srcset, which wins over src, so swap both. */
          var set = thumb.getAttribute("data-srcset");
          if (main && full) {
            if (set) main.srcset = set; else main.removeAttribute("srcset");
            main.src = full;
          }
          gallery.querySelectorAll("[data-thumb]").forEach(function (t) { t.classList.remove("is-active"); });
          thumb.classList.add("is-active");
        });
      });
    });
  }

  /* Variant <select>: reflect the chosen variant's price and sale strikethrough. */
  function wireVariants() {
    document.querySelectorAll("[data-variant-select]").forEach(function (select) {
      var wrap = document.querySelector("[data-product-price]");
      if (!wrap) return;
      var cur = wrap.querySelector("[data-current-price]");
      var was = wrap.querySelector("[data-compare-price]");
      select.addEventListener("change", function () {
        var opt = select.options[select.selectedIndex];
        if (!opt) return;
        if (opt.dataset.price) {
          if (cur) cur.textContent = opt.dataset.price;
          else wrap.textContent = opt.dataset.price;
        }
        if (was) {
          if (opt.dataset.compare) { was.textContent = opt.dataset.compare; was.hidden = false; }
          else { was.hidden = true; }
        }
        var deal = document.querySelector("[data-price-deal]");
        if (deal) {
          deal.hidden = !opt.dataset.save;
          var save = deal.querySelector("[data-price-deal-save]");
          if (save) save.textContent = opt.dataset.save ? "You save " + opt.dataset.save : "";
        }
        var badge = document.querySelector("[data-sale-badge]");
        if (badge) badge.hidden = !opt.dataset.compare;
      });
    });
  }

  /* Soft fade-up reveal as sections enter the viewport. Top-of-page sections
     (hero, product, collection, page band, offer) and anything already on
     screen at load are never hidden, so the first paint is not delayed. */
  function wireReveal() {
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    if (!("IntersectionObserver" in window)) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var els = Array.prototype.filter.call(
      document.querySelectorAll(".care, .menu, .elder, .nutfacts, .bigtext, .founder, .reviews, .bigbox, .corder"),
      function (el) {
        if (el.closest(".hero, .product, .collection, .page-band, .offer")) return false;
        return el.getBoundingClientRect().top >= vh;
      }
    );
    if (!els.length) return;
    els.forEach(function (el) { el.classList.add("reveal"); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in-view"); io.unobserve(e.target); } });
    }, { threshold: 0 });
    els.forEach(function (el) { io.observe(el); });
  }

  function openTargetDetails() {
    function openFromHash() {
      var id = (window.location.hash || "").replace("#", "");
      if (!id) return;
      var el = document.getElementById(id);
      if (el && el.tagName === "DETAILS") {
        el.open = true;
        el.scrollIntoView();
      }
    }
    openFromHash();
    window.addEventListener("hashchange", openFromHash);
  }

  /* ---------- Cart page ----------
     − / + change the number straight away, then the cart saves after a short
     pause (so three quick taps make one request). Shopify re-renders the
     lines and totals (Section Rendering API), so the page never reloads or
     jumps. Without JavaScript the form and the Remove links still work. */
  function wireCartPage() {
    var root = document.querySelector("[data-cart-page]");
    if (!root) return;
    var sectionId = root.getAttribute("data-section-id");
    var timers = {};  /* key -> pending save timer */
    var wanted = {};  /* key -> quantity the shopper picked that is not saved yet */
    var queue = {};   /* key -> quantity waiting for the request in flight */
    var busy = false;

    function announce(text) {
      var el = root.querySelector("[data-cart-status]");
      if (el) el.textContent = text;
    }

    function setError(message) {
      var el = root.querySelector("[data-cart-error]");
      if (!el) return;
      el.textContent = message || "";
      el.hidden = !message;
    }

    function inputFor(key) {
      return root.querySelector('[data-cart-input][data-key="' + key + '"]');
    }

    function showQty(input, qty) {
      input.value = qty;
      var minus = input.closest(".citem").querySelector('[data-cart-step="-1"]');
      if (!minus) return;
      if (qty <= 1 && document.activeElement === minus) input.focus();
      minus.disabled = qty <= 1;
    }

    function swap(doc, selector) {
      var current = root.querySelector(selector);
      var fresh = doc.querySelector(selector);
      if (current && fresh) current.replaceWith(fresh);
    }

    /* Put fresh HTML in place, keep numbers the shopper is still changing,
       and keep keyboard focus where it was. */
    function applyHtml(html) {
      var doc = new DOMParser().parseFromString(html, "text/html");
      var active = document.activeElement;
      var inside = active && root.contains(active) && active.closest("[data-cart-head], [data-cart-quick], [data-cart-items], [data-cart-totals]");
      var focusId = inside ? active.getAttribute("data-focus-id") : null;
      var empty = !doc.querySelector("[data-cart-items]");
      if (empty) {
        swap(doc, "[data-cart-body]");
      } else {
        swap(doc, "[data-cart-head]");
        swap(doc, "[data-cart-quick]");
        swap(doc, "[data-cart-items]");
        swap(doc, "[data-cart-totals]");
      }
      Object.keys(wanted).forEach(function (key) {
        var input = inputFor(key);
        if (input) showQty(input, wanted[key]);
      });
      if (inside || empty) {
        var el = focusId ? root.querySelector('[data-focus-id="' + focusId + '"]') : null;
        if (el && el.disabled) el = el.closest(".citem").querySelector("[data-cart-input]");
        (el || root.querySelector("[data-cart-title]")).focus();
      }
    }

    function refresh() {
      return fetch(window.location.pathname + "?section_id=" + encodeURIComponent(sectionId))
        .then(function (r) { if (!r.ok) throw new Error("refresh failed"); return r.text(); })
        .then(applyHtml);
    }

    function save(key, qty) {
      if (busy) { queue[key] = qty; return; }
      busy = true;
      setError("");
      root.classList.add("is-busy");
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: qty, sections: [sectionId], sections_url: window.location.pathname })
      })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (body) {
            if (!r.ok) {
              /* For example "You can only add 5 of this item." Show it, then resync the numbers. */
              delete wanted[key];
              setError(body.description || body.message || "Sorry, that change did not go through. Please try again.");
              return refresh();
            }
            if (!body.sections || !body.sections[sectionId]) throw new Error("no section");
            if (wanted[key] === qty && !timers[key] && !(key in queue)) delete wanted[key];
            applyHtml(body.sections[sectionId]);
            updateCount(body);
            announce(body.item_count ? "Cart updated. Total " + money(body.total_price, body.currency) + "." : "Your cart is empty.");
          });
        })
        .catch(function () { window.location.reload(); })
        .then(function () {
          busy = false;
          root.classList.remove("is-busy");
          var next = Object.keys(queue)[0];
          if (next) { var q = queue[next]; delete queue[next]; save(next, q); }
        });
    }

    function schedule(key, qty) {
      wanted[key] = qty;
      clearTimeout(timers[key]);
      timers[key] = setTimeout(function () { delete timers[key]; save(key, qty); }, 450);
    }

    root.addEventListener("click", function (e) {
      var step = e.target.closest("[data-cart-step]");
      if (step) {
        var input = step.closest(".citem").querySelector("[data-cart-input]");
        var qty = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute("data-cart-step"), 10));
        showQty(input, qty);
        schedule(input.getAttribute("data-key"), qty);
        return;
      }
      var remove = e.target.closest("[data-cart-remove]");
      if (remove) {
        e.preventDefault();
        var key = remove.getAttribute("data-key");
        clearTimeout(timers[key]);
        delete timers[key];
        delete wanted[key];
        save(key, 0);
      }
    });

    root.addEventListener("change", function (e) {
      var input = e.target.closest("[data-cart-input]");
      if (!input) return;
      var qty = Math.max(1, parseInt(input.value, 10) || 1);
      showQty(input, qty);
      schedule(input.getAttribute("data-key"), qty);
    });

    /* Enter in a quantity box saves it instead of submitting the form to checkout. */
    root.addEventListener("keydown", function (e) {
      if (e.key !== "Enter" || !e.target.matches || !e.target.matches("[data-cart-input]")) return;
      e.preventDefault();
      e.target.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    sendDevice();
    pageExpressStatus();
    primeMarquees();
    wireAddToCart();
    wireQuantity();
    wireCartPage();
    wireGallery();
    wireVariants();
    wireReveal();
    openTargetDetails();
  });
})();
